import React from 'react';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import DataLoader from './components/DataLoader';

function App() {
  return (
    <ChakraProvider value={defaultSystem}>
      <DataLoader />
    </ChakraProvider>
  );
}

export default App;
